export const MuiInputLabel = {
    styleOverrides: {
        root: ({ theme }) => ({
            lineHeight: "24px",
            letterSpacing: "0.15px",
            "&.MuiInputLabel-outlined": {
                "&.MuiInputLabel-shrink": {
                    transform: "translate(16px, -9px) scale(0.75)"
                },
                "&:not(.MuiInputLabel-shrink)": {
                    transform: "translate(14px, 11px) scale(1)",
                    "&.MuiInputLabel-sizeSmall": {
                        transform: "translate(14px, 8px) scale(1)"
                    }
                }
            },
            "&.Mui-error": {
                "&:not(.MuiInputLabel-shrink)": {
                    color: theme.palette.text.secondary
                }
            }
        })
    }
};
//# sourceMappingURL=InputLabel.js.map